var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("甘肃信息惠民服务热线接线统计")]),_c('h2',[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"charts",attrs:{"id":"main"}})])}
var staticRenderFns = []

export { render, staticRenderFns }